module.exports = __webpack_public_path__ + "img/com13.db948a11.gif";